import lazyWithRetry from '@shared/lib/lazyWithRetry';

import Loadable from '@components/Loadable/Loadable';

import { AdminPanelFeedbackUsers } from '@features/AdminPanelFeedbackUsers';
import { SettingsDemandReportUsers } from '@features/SettingsDemandReportUsers';
import AdminTokenUsage from '@features/admin-token-usage/containers/AdminTokenUsage';
import { AdminTokenUsageProvider } from '@features/admin-token-usage/contexts/AdminTokenUsageContext';
import AdminCreditUsage from '@features/admin-credit-usage/containers/AdminCreditUsage';
import { AdminCreditUsageProvider } from '@features/admin-credit-usage/contexts/AdminCreditUsageContext';
import AiPrompts from '@features/AIPropmts/ui/AIPrompts';
import DocumentPromptPreviewPage from '@pages/SuperAdminPanelPage/DocumentPromptPreviewPage';
import DocumentTemplatePage from '@pages/SuperAdminPanelPage/DocumentTemplatePage';
import SettingsUsersPage from '@pages/SettingsPage/Users';
import MultiDocumentAgentPage from '@pages/SuperAdminPanelPage/MultiDocumentAgentPage';
import UseCaseGroupPage from '@pages/SuperAdminPanelPage/UseCaseGroupPage';
import { SuperAdminProtectedRoute } from '@providers/SuperAdminProtectedRoute/ui/SuperAdminProtectedRoute';
import { AdminAreaRoute, AdminIndexRedirect } from './AdminAreaRoute';

const SuperAdminPanelPage = Loadable(
  lazyWithRetry(() => import('@pages/SuperAdminPanelPage'))
);

// Every /admin address is guarded here (ZLAYT-1241). Hiding tabs was the only
// protection before, so a normal user could open any admin page by typing its
// address. Super admins get everything; firm accounts get only the tabs listed
// in FIRM_ACCOUNT_ADMIN_TABS (@pages/SuperAdminPanelPage/access); anyone else
// is sent to /home.
const SuperAdminChildRoutes = {
  path: 'admin',
  element: (
    <AdminAreaRoute>
      <SuperAdminPanelPage />
    </AdminAreaRoute>
  ),
  children: [
    { path: '', element: <AdminIndexRedirect /> },
    // Firm accounts: data the server already limits to their own firm.
    { path: 'document-prompt-preview', element: <DocumentPromptPreviewPage /> },
    {
      path: 'token-usage',
      element: (
        <AdminTokenUsageProvider>
          <AdminTokenUsage />
        </AdminTokenUsageProvider>
      ),
    },
    {
      path: 'credit-usage',
      element: (
        <AdminCreditUsageProvider>
          <AdminCreditUsage />
        </AdminCreditUsageProvider>
      ),
    },
    // Super admins only.
    {
      element: <SuperAdminProtectedRoute />,
      children: [
        { path: 'multi-document-agent', element: <MultiDocumentAgentPage /> },
        { path: 'use-case-groups', element: <UseCaseGroupPage /> },
        { path: 'document-templates', element: <DocumentTemplatePage /> },
        { path: 'users', element: <SettingsUsersPage /> },
        { path: 'user-feedback-report', element: <AdminPanelFeedbackUsers /> },
        { path: 'reports', element: <SettingsDemandReportUsers /> },
        { path: 'ai-prompts', element: <AiPrompts /> },
      ],
    },
  ],
};

export default SuperAdminChildRoutes;
